import { render, staticRenderFns } from "./AufgabenComponentAufgabeDelegieren.vue?vue&type=template&id=fc63ec20&scoped=true"
import script from "./AufgabenComponentAufgabeDelegieren.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentAufgabeDelegieren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc63ec20",
  null
  
)

export default component.exports